import mitt from "mitt";
const emitter = mitt();

const eventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
  emitter,
};

export function initEventBus(Vue) {
  Vue.prototype.$eventBus = eventBus;
}

export default eventBus;
